<template>
  <div
    class="d-flex relative-lang languages"
    :class="[
      right ? 'justify-end' : null,
      $vuetify.breakpoint.smAndDown ? 'text-color' : null
    ]"
  >
    <div v-if="loading" class="pa-3">
      <v-progress-circular indeterminate size="18" class="ma-1" />
      {{ $t("common:loading.messsage", "Loading...", "Loading message") }}
    </div>
    <template v-else>
      <div
        v-for="lng in languages"
        :key="lng"
        class="d-flex"
        style="align-items: center;"
      >
        <button class="language-btn" @click.prevent="changeLang(lng)">
          {{ $t("navigation:menu.language." + lng) }}
        </button>
        <div class="seperator" />
      </div>
    </template>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import i18next from "i18next";
import { getFederationConfiguration } from "@composables/masterdata/config";
import initGoogleMaps from "@/plugins/googleMaps";
import { refreshHelpscoutBeacon } from "@/plugins/beacon";

export default defineComponent({
  name: "AppLanguageBar",
  props: {
    right: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      ...getFederationConfiguration()
    };
  },
  data() {
    return {
      current: i18next.language,
      loading: false
    };
  },
  computed: {
    languages: ({ masterConfiguration, current }) =>
      masterConfiguration?.translatedLanguages?.filter(
        locale => locale != current
      ) ?? []
  },
  methods: {
    changeLang(newLng) {
      if (newLng === this.current) return;
      this.loading = !i18next.hasResourceBundle(newLng, "common");
      const locale = newLng;
      switch (locale) {
        case "nb-NO":
          this.$dayjs.locale("nb"); // dayjs does not have nb-NO
          break;
        default:
          this.$dayjs.locale(newLng);
      }

      localStorage.setItem("lang", newLng);
      document.querySelector("html").setAttribute("lang", newLng.split("-")[0]);

      i18next.changeLanguage(newLng, async err => {
        if (err) {
          console.error(
            "Something went wrong loading translations after changing language",
            err
          );
        }

        this.current = newLng;
        this.loading = false;
        refreshHelpscoutBeacon(newLng);
        // triggers event listeners that are created to refresh apollo data (like cached masterdata name fields) or refetch whole query again
        window.dispatchEvent(new CustomEvent("manualApolloRefresh"));
      });
    }
  }
});
</script>
<style lang="scss">
.smaller-badge {
  z-index: 5;
  .v-badge__badge {
    transform: translate(2px, -5px);
    i {
      font-size: 12px;
    }
  }
}
.text-color {
  color: var(--v-mainMenuText-base);
  opacity: 0.6;
}

.relative-lang > div {
  position: relative;
}
.language-btn {
  padding: 4px 8px;
  border-radius: 4px;
  position: relative;
  cursor: pointer;

  &:hover::before {
    opacity: 0.08;
  }
  &:focus::before {
    opacity: 0.24;
  }

  &::before {
    bottom: 0;
    color: inherit;
    content: "";
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    border-radius: 4px;
    right: 0;
    top: 0;
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
    background-color: currentColor;
  }
}
.languages {
  margin: 0 4px;
  opacity: 0.6;
  .seperator {
    width: 1px;
    height: 18px;
    opacity: 0.6;
    background-color: currentColor;
    margin: 0 6px;
  }

  div:last-child {
    .seperator {
      display: none;
    }
  }
}
</style>
